import debug from 'debug';
import { onAvailable } from "@core/lib/on-available";
import plugin from '../../lib/plugin';
import { tmpl } from '../../lib/strings';

const MODULE_NAME = 'app.core/modules/quote';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-add-to-quote]';
const FORM_ADD_TYPE = 'data-add-to-quote-add-type';
const PROGRESS_CLASS = 'has-progress';

//  todo pull these from CMS editable page somehow
const validationMessages = {
	// empty: 'What quantity would you like quoted?',
	// min: 'What quantity would you like quoted?',
	// max: 'Sorry you can’t order more than {{max}}',
	integer:
		$(`meta[name="site.addToQuoteValidation.integer"]`).attr('content') ||
		'Oops! Enter the number as digits only please.',
	connection:
		$(`meta[name="site.addToQuoteValidation.connection"]`).attr(
			'content'
		) ||
		'An error occurred sending your request to the server. Please try again later.',
};

const quantityTests = [
	// {
	//     //  is not empty
	//     test: value => value !== '',
	//     message: 'empty'
	// },
	{
		// is integer
		test: (value) => Number.isInteger(value),
		message: 'integer',
	},
	// ,
	// {
	//     // is not less than min (1)
	//     test: value => value > 0,
	//     message: 'min'
	// }
	//  Max test not required at this time
	// ,{
	//     // is not more than max
	//     test: (value, max) => value <= max,
	//     message: `max`
	// }
];

function getMessage(messageName, context) {
	const message = validationMessages[messageName] || false;
	return context ? tmpl(message, context) : message;
}

//  Note the {max} value here is not needed
//  left as example of rendering a dynamic value into a error message
function validateQty(value, max) {
	const error = quantityTests.reduce((result, validator) => {
		return result
			? result
			: validator.test(value, max)
			? false
			: getMessage(validator.message, { max });
	}, false);

	//  Return true or error message encountered
	return error;
}

class AddToQuotePlugin {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.$code = this.$element.find(this.options.codeInputSelector);
		this.addType = this.options.addType;
		this.$qty = this.$element.find(`[name="${this.options.field}"]`);
		this.$prefixInput = this.element.querySelector(
			this.options.prefixInputSelector
		);
		this.maxQty = this.$qty.attr('max');
		this.$custom = this.$element.find('[name="customise"]');
		this.$addToQuoteButton = this.$element.find(this.options.submitButton);
		this.$headerQuoteLink = $(this.options.quoteLink);
		this.$headerCartLink = $(this.options.cartLink);
		this.$quoteModal = $(this.options.quoteModal);
		this.$cartModal = $(this.options.cartModal);
		this.$productName = this.$element.find(this.options.productName);
		this.$cartModalProductTitle = this.$cartModal.find(
			this.options.modalProductTitle
		);
		this.$quoteModalProductTitle = this.$quoteModal.find(
			this.options.modalProductTitle
		);
		this.$changeMarketSubmitButton = $(
			this.options.changeMarketSubmitButton
		);
		this.$errorElement = this.$element.find(this.options.errorElement);
		this.errorClassname = this.options.errorClassname;

		log('AddToQuotePlugin', element);

		this.watch();
	}

	getErrors() {
		return validateQty(+this.$qty.val(), +this.maxQty);
	}

	onQtyInput(event) {
		//  ignore: enter, shift, alt, tab, meta key strokes (meta has multiple codes)
		const ignoreKeys = [13, 16, 18, 9, 91, 92, 93, 224];

		//  Ignore keystrokes with modifier key
		if (ignoreKeys.indexOf(event.which) !== -1) {
			return true;
		}

		const error = this.getErrors();

		if (error) {
			this.handleErrors([error], 'client');
		} else {
			this.clearErrors();
		}
	}

	onAddQtyExit() {
		const value = this.$qty.val().trim();

		// if value is emptish: '', '0'
		if (value === '' || value === '0') {
			this.clearErrors();
			this.$qty.val('');
		}
	}

	//  0 is a valid value for update form
	onUpdateQtyExit() {
		const value = this.$qty.val().trim();

		// if value is empty: ''
		if (value === '') {
			this.clearErrors();
			this.$qty.val('');
		}
	}

	catchEnter(event) {
		if (event.which === 13 /* enter */) {
			event.preventDefault();
			this.submit();
		}
	}

	//  Used on view quote page
	onSubmit(event) {
		const error = this.getErrors();

		if (error) {
			event.preventDefault();
			this.handleErrors([error], 'client');
		}
	}

	onAjaxSubmit(event) {
		event.preventDefault();
		this.submit();
	}

	getCustomValue($input) {
		if (!$input.length) {
			return 'false';
		}

		if ($input.is(':checkbox')) {
			return $input.is(':checked') && $input.val();
		}

		//  hidden input
		return $input.val();
	}

	submit() {
		const error = this.getErrors();

		if (error) {
			this.handleErrors([error], 'client');
			return false;
		}

		if (this.$code.val().length > 0) {
			log('submitted', this.$element);
			this.$addToQuoteButton
				.addClass(PROGRESS_CLASS)
				.attr('disabled', 'disabled');
			this.post();
		}
	}

	watch() {
		log('ajax', this.options.ajax);
		const submitHandler =
			this.options.ajax === true
				? this.onAjaxSubmit.bind(this)
				: this.onSubmit.bind(this);

		const exitQtyInputHandler =
			this.options.type === 'add'
				? this.onAddQtyExit.bind(this)
				: this.onUpdateQtyExit.bind(this);

		if (this.$element.is('form')) {
			this.$element.on('submit.addToQuote', submitHandler);
		} else {
			this.$addToQuoteButton.on(
				'click.addToQuote',
				this.onAjaxSubmit.bind(this)
			);

			//  avoid submitting containing product listing filter form
			this.$qty.on('keydown.addToQuote', this.catchEnter.bind(this));
		}

		this.$qty.on('keyup.addToQuote', this.onQtyInput.bind(this));
		this.$qty.on('blur.addToQuote', exitQtyInputHandler);
	}

	unwatch() {
		this.$element.off('.addToQuote');
		this.$addToQuoteButton.off('.addToQuote');
		this.$qty.off('.addToQuote');

		log('unbound', this.$element);
	}

	onSuccess(result) {
		this.$addToQuoteButton
			.removeClass(PROGRESS_CLASS)
			.removeAttr('disabled');

		if (typeof result.Success !== 'undefined' && result.Success) {
			var itemsInQuote = 0;
			var itemsInCart = 0;
			if (
				typeof result.ItemsInQuote !== 'undefined' &&
				result.ItemsInQuote > 0
			) {
				itemsInQuote = result.ItemsInQuote;
				if (this.$headerQuoteLink.find('.count').length == 0) {
					this.$headerQuoteLink.append(
						'<span class="count">' + result.ItemsInQuote + '</span>'
					);
				} else {
					this.$headerQuoteLink
						.find('.count')
						.html(result.ItemsInQuote);
				}
			}
			if (
				typeof result.ItemsInCart !== 'undefined' &&
				result.ItemsInCart > 0
			) {
				itemsInCart = result.ItemsInCart;
				if (this.$headerCartLink.find('.count').length == 0) {
					this.$headerCartLink.append(
						'<span class="count">' + result.ItemsInCart + '</span>'
					);
				} else {
					this.$headerCartLink
						.find('.count')
						.html(result.ItemsInCart);
				}
			}
			if (this.addType == 'cart') {
				this.openModal(this.$cartModal, this.$cartModalProductTitle);
			} else {
				this.openModal(this.$quoteModal, this.$quoteModalProductTitle);
			}
			this.resetForm(itemsInQuote, itemsInCart);
		} else {
			var errorList =
				typeof result.ValidationMessages !== 'undefined'
					? result.ValidationMessages
					: Array();
			log('addToQuoteServerError', errorList);
			this.handleErrors(errorList, 'server');
		}
	}

	handleErrors(errorList, errorSource) {
		const errorMessage = errorList.join(' ');
		const submitErrorClass =
			errorSource == 'submit' ? this.options.submitErrorClassname : '';
		if (this.$errorElement.length > 0) {
			this.$errorElement.empty().append(errorMessage);
		}

		this.$qty.addClass(`${this.errorClassname} ${submitErrorClass}`);
	}

	clearErrors() {
		this.$qty.removeClass(
			`${this.errorClassname} ${this.options.submitErrorClassname}`
		);
		this.$errorElement.empty();
	}

	resetForm(itemsInQuote, itemsInCart) {
		this.$qty.val('').trigger('keyup');

		this.clearErrors();

		$(document).trigger('added-to-cart');

		if (
			this.$changeMarketSubmitButton.length > 0 &&
			(itemsInQuote > 0 || itemsInCart > 0)
		) {
			if (this.$changeMarketSubmitButton.attr('type') == 'submit') {
				this.$changeMarketSubmitButton.attr('type', 'button');
				this.$changeMarketSubmitButton.attr(
					'data-open',
					'market-change-confirm-modal'
				);
			}
		}
	}

	getPostParams() {
		const result = {
			//  If no quantity entered in the qty field - presume 1
			qty: this.$qty.val() || '1',
			code: this.$code.val(),
			custom: this.getCustomValue(this.$custom) || 'false'
		};

		// Omit prefix param if absent
		const prefixParam =
			this.$prefixInput && this.$prefixInput.value
				? {
						prefix: this.$prefixInput.value,
				  }
				: {};

		return Object.assign(result, prefixParam);
	}

	openModal(modal, $productTitle) {
		$productTitle.html(this.$productName.val());
		modal.foundation('open');
	}

	post() {
		this.addType = this.$element.attr(FORM_ADD_TYPE);

		var endpointUrl =
			this.addType == 'cart'
				? this.options.endpointCartUrl
				: this.options.endpointQuoteUrl;

		const urlSearch = Object.entries(this.getPostParams())
			.map(([key, val]) => `${key}=${val}`)
			.join('&');

		const url = `${endpointUrl}?${urlSearch}`;

		var token = $(
			'#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]'
		).val();

		log('accepting', this.$element, url);
		$.ajax({
			url,
			method: 'post',
			data: {
				__RequestVerificationToken: token,
			},
			success: (result) => {
				this.onSuccess(result);
			},
			error: (e) => {
				log('addToQuoteAjaxError', e);
				this.$addToQuoteButton
					.removeClass(PROGRESS_CLASS)
					.removeAttr('disabled');
				this.handleErrors([validationMessages.connection], 'submit');
			},
		}).done(() => {
			log('accepted', this.$element, url);
		});
	}
}

AddToQuotePlugin.DEFAULTS = {
	field: 'qty',
	type: 'add',
	endpointQuoteUrl: $(`meta[name="site.addToQuoteApiEndpoint"]`).attr(
		'content'
	),
	endpointCartUrl: $(`meta[name="site.addToCartApiEndpoint"]`).attr(
		'content'
	),
	productName: '[name="productName"]',
	codeInputSelector: '[name="code"]',
	prefixInputSelector: '[name="prefix"]',
	modalProductTitle: '[data-added-to-quote-title]',
	quoteLink: '#header-quote-link',
	cartLink: '#header-cart-link',
	quoteModal: '#added-to-quote-modal',
	cartModal: '#added-to-cart-modal',
	changeMarketSubmitButton: '#marketChangeButton',
	submitButton: '[type="submit"]',
	addType: 'cart',
	errorElement: '.error-message',
	errorClassname: 'error',
	submitErrorClassname: 'submit-error',
};

plugin('addToQuote', AddToQuotePlugin);

export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, (element) => {
		$(element).addToQuote();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/modules/quote/index.js